import { useState } from "react";

import { Button } from "~/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "~/components/ui/dialog";
import { Input } from "~/components/ui/input";
import { Label } from "~/components/ui/label";

const LEVEL_LETTERS = "ABCDEFGHIJ";

interface BulkPositionsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  rackCode?: string;
  onSubmit: (levels: number) => void;
  isLoading: boolean;
}

export function BulkPositionsDialog({
  open,
  onOpenChange,
  rackCode,
  onSubmit,
  isLoading,
}: BulkPositionsDialogProps) {
  const [levels, setLevels] = useState(5);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(levels);
  };

  const letterRange = Array.from(
    { length: levels },
    (_, i) => LEVEL_LETTERS[i]
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <form onSubmit={handleSubmit}>
          <DialogHeader>
            <DialogTitle>Crear Posiciones en Lote</DialogTitle>
            <DialogDescription>
              Genera posiciones por nivel para el rack{" "}
              <span className="font-mono font-medium">{rackCode}</span>
            </DialogDescription>
          </DialogHeader>

          <div className="grid gap-4 py-4">
            <div className="grid grid-cols-4 items-center gap-4">
              <Label htmlFor="levels" className="text-right">
                Niveles
              </Label>
              <Input
                id="levels"
                type="number"
                min={1}
                max={10}
                value={levels}
                onChange={(e) => setLevels(parseInt(e.target.value) || 1)}
                className="col-span-3"
              />
            </div>

            <div className="rounded-lg bg-muted p-4">
              <p className="text-sm text-muted-foreground">
                Se crearán <span className="font-medium">{levels}</span>{" "}
                posiciones con el formato:
              </p>
              <ul className="mt-2 space-y-1 font-mono text-sm">
                {letterRange.map((letter) => (
                  <li key={letter}>
                    {rackCode}-{letter}
                  </li>
                ))}
              </ul>
              <p className="mt-3 text-xs text-muted-foreground">
                Niveles B-C tendrán score ergonómico óptimo (50), otros tendrán
                scores menores según su altura.
              </p>
            </div>
          </div>

          <DialogFooter>
            <Button
              type="button"
              variant="outline"
              onClick={() => onOpenChange(false)}
            >
              Cancelar
            </Button>
            <Button type="submit" disabled={isLoading}>
              {isLoading ? "Creando..." : `Crear ${levels} Posiciones`}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
